<script setup lang="ts">
import type { Flat } from '~/types/types'
import { useGhostStuff, useState } from '#imports'

const Flats = useState<Record<number, Flat>>('Flats')
const ghostStuff = useGhostStuff()
</script>

<template>
  <svg
    viewBox="0 0 1400 730"
  >
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="354.9 276.9 354.8 353 301.9 353.3 301.8 338.3 248.9 338.5 248.6 276.9 182.7 277.2 182.7 199.4 301.9 199.5 301.8 276.6 354.9 276.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-5"
      :class="['fill-ghost-'+Flats[-5]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="625.8 353 625.8 505.9 482 505.3 483.1 177.4 890.7 177.6 890.7 353 625.8 353"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="323.5 462.5 323.8 479.5 314.9 479.5 314.9 507 311.4 507 311.4 499.2 305.1 499.3 305.2 506.6 256.3 506.6 256.3 500.9 248.3 500.7 248.6 570.6 160.8 570.3 160.8 425.4 324.4 425.1 324.6 462.5 323.5 462.5"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="376.9 538.3 376.5 622.5 305.3 622.3 305.1 567.3 346 567.5 345.7 538.3 376.9 538.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-6"
      :class="['fill-ghost-'+Flats[-6]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="355.1 276.9 354.8 353 447.3 353 446.9 178.8 301.8 179.5 301.8 276.6 355.1 276.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="301.9 353.3 302.1 338.5 248.6 338.3 248.6 277.2 160.7 277.2 160.8 425.5 324.2 425.3 324.6 385 314.9 385 314.9 353.3 301.9 353.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="256.6 506.3 256.3 500.9 248.6 500.9 248.6 570.6 182.7 570.5 182.8 648 305.1 647.6 305.1 567.3 346 567.2 345.7 538.3 368.3 538.3 372.2 507.3 311.7 507.4 311.4 514.4 304.1 514.4 304.1 506.6 256.6 506.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-1"
      :class="['fill-ghost-'+Flats[-1]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="625.2 507.1 625.8 570.1 603.8 570.5 603.7 648 481.4 648 481.4 622.3 409.8 622.3 409.7 538.3 414.6 538.3 414.6 507.3 440.4 507 440.4 511.5 453.3 511.6 453.4 507.2 625.2 507.1"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-4"
      :class="['fill-ghost-'+Flats[-4]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="1214.6 179.3 1214.6 199.5 1333.7 199.5 1333.7 277.1 1355.7 277.4 1355.6 570.3 1333.7 570.4 1333.8 648.1 1211.3 648 1211.1 622.3 1035.2 622.3 1035.2 647.9 912.7 648 912.7 570.3 890.7 570.1 890.7 177.6 1036.9 177.3 1074.4 177.3 1074.7 179.3 1214.6 179.3"
      @click="ghostStuff.openLink"
    />
    <rect
      id="-2"
      :class="['fill-ghost-'+Flats[-2]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      x="696.2"
      y="35.6"
      width="121.5"
      height="112.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-3"
      :class="['fill-ghost-'+Flats[-3]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="899.5 35.1 982.8 35.7 983.1 56 991.6 64.7 982.2 73.1 982.3 97.1 953.5 97.2 953.5 147.9 899.5 147.9 899.5 35.1"
      @click="ghostStuff.openLink"
    />
    <rect
      id="-3"
      :class="['fill-ghost-'+Flats[-3]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      x="817.7"
      y="34.7"
      width="81.8"
      height="113.2"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="-3"
      :class="['fill-ghost-'+Flats[-3]?.status_name, 'ghost-element', 'fill-ghost-Special']"
      points="696.2 35.7 533.4 35.5 533.6 55.8 525.7 63.7 534.7 72.8 534.8 97.2 588.3 97.3 588.3 148 696.2 147.9 696.2 35.7"
      @click="ghostStuff.openLink"
    />
  </svg>
</template>
